import React, { createContext, useContext, useState } from 'react';

// Create the context
const OpenContext = createContext(undefined);

const OpenProvider = ({ children }) => {
  const [open, setOpen] = useState(true);

  return <OpenContext.Provider value={[open, setOpen]}>{children}</OpenContext.Provider>;
};

const useOpen = () => {
  const context = useContext(OpenContext);
  if (context === undefined) {
    throw new Error('usesidebarOpen must be used within a sidebarOpenProvider');
  }
  return context;
};

export { OpenProvider, useOpen };
